import t, { useState as V, useEffect as H } from "react";
import { useTranslation as I } from "react-i18next";
import Y from "../../../hooks/customization/useCustomization.js";
import { useEnvironment as z } from "../../../../../../features/common/hooks/environment/useEnvironment.js";
import { useMapsApi as B } from "../../../../../../features/google/hooks/useMapsApi.js";
import { ServiceType as w } from "../../../../../../../common/shared/serviceType.js";
import { OrderButton as R } from "../OrderButton/OrderButton.js";
import { useOrdering as K } from "../context.js";
import c from "./steps.module.scss.js";
import j from "../../Restaurant/Restaurant.js";
import q from "../../../hooks/useOrderLater.js";
function te() {
  const { mapApiKey: y } = z(), {
    isApiReady: m,
    getDistanceMatrix: L
  } = B(y), { t: n } = I(), {
    currentStep: d,
    form: p,
    setStep: u,
    back: O
  } = K(), { isLoading: g, orderLater: C } = q(), {
    configuration: e,
    getTextTranslations: b
  } = Y(), s = b("popup"), {
    service: o,
    restaurants: i
  } = d.data, l = o !== w.DELIVERY, [h] = i, r = i.find((a) => a.is_now_available) || h, S = i.find((a) => a.is_schedule_available) || h, [T, k] = V(0);
  H(() => {
    (async () => {
      var E, f, v, _;
      if (!m || d.data.service !== w.DELIVERY || !(e != null && e.settings.popup.showOrderEta))
        return;
      const a = await L(
        [((E = p.place) == null ? void 0 : E.formattedAddress) ?? ""],
        [r.address]
      );
      k(((_ = (v = (f = a == null ? void 0 : a.rows[0]) == null ? void 0 : f.elements[0]) == null ? void 0 : v.duration) == null ? void 0 : _.value) || 60);
    })();
  }, [r, m, e]);
  const N = async () => {
    const a = await C(
      i,
      o,
      p.place
    );
    u({
      name: "time-selector",
      data: a
    });
  }, A = async () => {
    u({
      name: "restaurant-redirection",
      data: {
        service: o,
        restaurant: r,
        now: !0
      }
    });
  }, D = (e == null ? void 0 : e.design.colors.general.highlightHighlight) ?? "#EA565C", M = (T || 0) + (r.time_till_on_route || 0) + (r.preparation_time || 0), x = Math.round(M / 60);
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "single-restaurant-step" }, /* @__PURE__ */ t.createElement("div", { className: c.formTitle }, /* @__PURE__ */ t.createElement("i", { onClick: () => O(), className: "lni lni-chevron-left" }), l && ((s == null ? void 0 : s.single_restaurant_title) || n("shopLanding.singleRestaurant.title")), !l && n("shopLanding.singleRestaurant.delivery.title")), l && /* @__PURE__ */ t.createElement(
    j,
    {
      ...r,
      accent: D
    }
  ), (e == null ? void 0 : e.settings.popup.showOrderEta) && r.is_now_available && /* @__PURE__ */ t.createElement("div", { className: c.eta }, /* @__PURE__ */ t.createElement("span", null, (s == null ? void 0 : s.single_restaurant_eta) || n("shopLanding.singleRestaurant.eta")), " ", /* @__PURE__ */ t.createElement("span", { style: { color: e == null ? void 0 : e.design.colors.general.highlightHighlight } }, n("shopLanding.singleRestaurant.eta.time", { time: x }))), /* @__PURE__ */ t.createElement("div", { className: c.buttonContainer }, /* @__PURE__ */ t.createElement(
    R,
    {
      restaurant: S,
      type: "later",
      disabled: g,
      onClick: () => N()
    }
  ), /* @__PURE__ */ t.createElement(
    R,
    {
      restaurant: r,
      type: "now",
      disabled: g,
      onClick: () => A()
    }
  )));
}
export {
  te as default
};
//# sourceMappingURL=SingleRestaurantStep.js.map
